import { RoutePath } from 'enums/routePath';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

const ROOT = `/companies`;

const COMPANY = `${ROOT}/:id`;
const COMPANY_INTERACTIONS = `${COMPANY}/interactions`;
const COMPANY_INTERACTIONS_LOGCALL = `${COMPANY_INTERACTIONS}/logcall`;
const COMPANY_INTERACTIONS_LOGMEETING = `${COMPANY_INTERACTIONS}/logmeeting`;
const COMPANY_INTERACTIONS_LOGEMAIL = `${COMPANY_INTERACTIONS}/logemail`;
const COMPANY_INTERACTIONS_LOGCOMPANYNOTE = `${COMPANY_INTERACTIONS}/logcompanynote`;

const COMPANY_INTERACTION = `${COMPANY_INTERACTIONS}/:interactionId`;
const COMPANY_CONTACTS = `${COMPANY}/contacts`;
const COMPANY_CONTRACTS = `${COMPANY}/contract-tracker`;
const COMPANY_PROFILE = `${COMPANY}/profile`;
const COMPANY_FILES = `${COMPANY}/files`;
const COMPANY_NEWS = `${COMPANY}/news`;

const COMPANY_REVENUE_HISTORY = `${COMPANY}/revenue-history`;
const COMPANY_PROFITABILITY = `${COMPANY}/profitability`;
const COMPANY_PROFITABILITY_CUMULATIVE = `${COMPANY}/profitability-cumulative`;
const COMPANY_MEETING_PLANNER = `${COMPANY}/meeting-planner`;

const COMPANY_PLANNING = `${COMPANY}/planning`;
const COMPANY_PLANNING_INTERACTION = `${COMPANY_PLANNING}/:interactionId`;

export const companyPaths = {
  [RoutePath.COMPANY]: COMPANY,
  [RoutePath.COMPANY_MEETING_PLANNER]: COMPANY_MEETING_PLANNER,

  [RoutePath.COMPANY_INTERACTIONS]: COMPANY_INTERACTIONS,
  [RoutePath.COMPANY_INTERACTIONS_LOGCALL]: COMPANY_INTERACTIONS_LOGCALL,
  [RoutePath.COMPANY_INTERACTIONS_LOGMEETING]: COMPANY_INTERACTIONS_LOGMEETING,
  [RoutePath.COMPANY_INTERACTIONS_LOGEMAIL]: COMPANY_INTERACTIONS_LOGEMAIL,
  [RoutePath.COMPANY_INTERACTIONS_LOGCOMPANYNOTE]:
    COMPANY_INTERACTIONS_LOGCOMPANYNOTE,
  [RoutePath.COMPANY_INTERACTION]: COMPANY_INTERACTION,
  [RoutePath.COMPANY_CONTRACTS]: COMPANY_CONTRACTS,
  [RoutePath.COMPANY_CONTACTS]: COMPANY_CONTACTS,
  [RoutePath.COMPANY_PROFILE]: COMPANY_PROFILE,
  [RoutePath.COMPANY_FILES]: COMPANY_FILES,
  [RoutePath.COMPANY_NEWS]: COMPANY_NEWS,
  [RoutePath.COMPANY_REVENUE_HISTORY]: COMPANY_REVENUE_HISTORY,
  [RoutePath.COMPANY_PROFITABILITY]: COMPANY_PROFITABILITY,
  [RoutePath.COMPANY_PROFITABILITY_CUMULATIVE]:
    COMPANY_PROFITABILITY_CUMULATIVE,
  [RoutePath.COMPANY_PLANNING]: COMPANY_PLANNING,
  [RoutePath.COMPANY_PLANNING_INTERACTION]: COMPANY_PLANNING_INTERACTION,
};

export const makeCompanyIdPathGetter =
  (id: string) =>
  (routePath: keyof typeof companyPaths = RoutePath.COMPANY) => {
    const path = companyPaths[routePath].replace(':id', id);
    return path;
  };

export const useCompanyDetailPath = () => {
  const { id } = useParams<Record<string, string>>();
  const getPath = useCallback(makeCompanyIdPathGetter(id), [id]);
  return { getPath };
};

export const companyPathArray = Object.values(companyPaths);

export const companiesPaths = {
  [RoutePath.COMPANIES]: ROOT,
};

const paths = {
  ...companiesPaths,
  ...companyPaths,
};

export const pathArray = Object.values(paths);

export default paths;
